<template>
    <div class="partner">
        <div class="triangle" id="triangle-partner">
            <div class="triangle-left" id="partner-triangle-left"></div>
            <div class="triangle-right" id="partner-triangle-right"></div>
        </div>
        <div class="title">
            <div class="title-content">合作伙伴</div>
        </div>

        <div class="partner-main-body" id="partner-main-body">
			<div class="img-partner">
			    <img src="../../../../assets/index/img/partner/宝钛集团LOGO.png">
			</div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/大全集团LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/恒顺集团LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/中化蓝天LOGO.png">
            </div>

            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/宝色股份LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/上海振华LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/杭叉LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/贵州轮胎LOGO.png">
            </div>

            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/哇哈哈LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/华章LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/中国电子节能协会LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/绿草地新能源LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/金风科技LOGO.png">
            </div>
            <div class="img-partner">
                <img src="../../../../assets/index/img/partner/杭州硕联LOGO.png">
            </div>
			<div class="img-partner">
			     <img src="../../../../assets/index/img/partner/footer/赛迪LOGO.png">
			</div>
			<div class="img-partner">
			     <img src="../../../../assets/index/img/partner/footer/浙江大学LOGO.png">
			</div>
			<div class="img-partner">
			     <img src="../../../../assets/index/img/partner/footer/上海交大LOGO.png">
			</div>
			<div class="img-partner">
			     <img src="../../../../assets/index/img/partner/footer/同济大学LOGO.png">
			</div>
			<div class="img-partner">
			      <img src="../../../../assets/index/img/partner/footer/杭州电子科技大学LOGO.png">
			</div>
			<div class="img-partner">
			       <img src="../../../../assets/index/img/partner/footer/浙江工业大学LOGO.png">
			</div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "partner",
        data(){
            return{
                width:document.body.clientWidth
            }
        },
        created(){
            this.width=document.body.clientWidth
        },
        mounted(){
            window.addEventListener('resize', this.handelWidth, false)
            this.handelWidth()
        },
        beforeDestroy(){
            window.removeEventListener("resize",this.handelWidth, false)
        },
        methods:{
            handelWidth(){
                this.width=document.body.clientWidth
                let w=document.body.clientWidth
                let partnerMainBody=document.getElementById("partner-main-body")
                let imgPartner=document.getElementsByClassName("img-partner")
                let trianglePartner=document.getElementById("triangle-partner")
                if(w>=1900){
                    partnerMainBody.style.paddingLeft="20%"
                    partnerMainBody.style.paddingRight="10%"
                    imgPartner.forEach(item=>{item.style.width="230px"})
                }else if (1688<=w&&w<1900){
                    partnerMainBody.style.paddingLeft="16%"
                    partnerMainBody.style.paddingRight="10%"
                    imgPartner.forEach(item=>{item.style.width="230px"})
                }else if (1585<=w&&w<1688){
                    partnerMainBody.style.paddingLeft="15%"
                    partnerMainBody.style.paddingRight="10%"
                    imgPartner.forEach(item=>{item.style.width="230px"})
                }else if (1494<=w&&w<1585){
                    partnerMainBody.style.paddingLeft="10%"
                    partnerMainBody.style.paddingRight="10%"
                    imgPartner.forEach(item=>{item.style.width="230px"})
                }else if (1387<=w&&w<1494){
                    partnerMainBody.style.paddingLeft="8%"
                    partnerMainBody.style.paddingRight="8%"
                    imgPartner.forEach(item=>{item.style.width="230px"})
                }else if (1270<=w&&w<1387){
                    partnerMainBody.style.paddingLeft="5%"
                    partnerMainBody.style.paddingRight="0%"
                    imgPartner.forEach(item=>{item.style.width="230px"})
                    trianglePartner.style.paddingLeft="40%"
                    trianglePartner.style.paddingRight="41%"
                }else if (1069<=w&&w<1270){
                    partnerMainBody.style.paddingLeft="4%"
                    partnerMainBody.style.paddingRight="0%"
                    imgPartner.forEach(item=>{item.style.width="190px"})
                    trianglePartner.style.paddingLeft="40%"
                    trianglePartner.style.paddingRight="41%"
                }else if (900<=w&&w<1069){
                    partnerMainBody.style.paddingLeft="16%"
                    // imgPartner.forEach(item=>{item.style.width="160px"})
                    trianglePartner.style.paddingLeft="38%"
                    trianglePartner.style.paddingRight="39%"
                }
            }
        }
    }
</script>

<style scoped>
    img{
        width: 90%;
    }
    .partner {
        height:800px;
        background:rgba(255,255,255,1);
        opacity:1;
        position: relative;
        height: 800px;
        width: 100%;
        overflow: auto;
    }
    .title{
        position: absolute;
        width: 100%;
        top: 45px;
    }
    .title-content{
        margin: 0 auto;
        width:300px;
        height:50px;
        font-size:36px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:50px;
        color:#F26821;
        letter-spacing:6px;
        opacity:1;
    }

    .triangle{
        width: 100%;
        position: absolute;
        top: 64px;
        padding-right: 41%;
        padding-left: 40%;
    }
    .triangle-left{
        border-color:  #fff #F26821 #fff #fff;
        border-style: solid;
        border-width: 6px 10px 6px  0px;
        height: 0;
        width: 0;
        float: left;
    }

    .triangle-right{
        border-color:  #fff #fff #fff #F26821;
        border-style: solid;
        border-width: 6px 0px 6px 10px;
        height: 0;
        width: 0;
        float: right;
    }

    .partner-main-body{
           position: absolute;
           top: 191px;
           width: 100%;
           padding-left: 10%;
            padding-right: 10%;
    }
    .img-partner{
        width: 230px;
        position: relative;
        margin-left: 27px;
        margin-right: 27px;
        margin-top: 15px;
        float: left;
    }
    .footer{
        position: relative;
        width: 100%;
        top: 220px;
        padding-left: 5%;
        padding-right: 1%;
        float: left;
    }
    .img-footer{
        position: relative;
        margin-left: 27px;
        margin-right: 27px;
        float: left;
    }


</style>
